import { isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, inject, PLATFORM_ID } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AdminAccessModalComponent } from '@banyan/modules/standalone/admin-access-modal/admin-access-modal.component';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
})
export class AdminLayoutComponent {
  dialog = inject(MatDialog);
  alreadyLaunched = false;

  constructor(@Inject(PLATFORM_ID) private readonly platformId: any) {
    this.checkLayoutWidth();
  }

  @HostListener('window:resize', ['$event'])
  checkLayoutWidth() {
    if (isPlatformBrowser(this.platformId)) {
      const width = window.innerWidth;
      if (width < 961) {
        if (!this.alreadyLaunched) {
          this.alreadyLaunched = true;
          this.dialog.open(AdminAccessModalComponent);
        }
      }
    }
  }
}